<div class="row">
    <mm-select-dropdown-control id="trust-paid-for-dropdown" [parentForm]="parentForm"
        [selectModel]="paidForDropdownModel$"></mm-select-dropdown-control>
</div>